import { render, staticRenderFns } from "./RouteItem.vue?vue&type=template&id=7200e305&scoped=true&"
import script from "./RouteItem.vue?vue&type=script&lang=js&"
export * from "./RouteItem.vue?vue&type=script&lang=js&"
import style0 from "./RouteItem.vue?vue&type=style&index=0&id=7200e305&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7200e305",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7200e305')) {
      api.createRecord('7200e305', component.options)
    } else {
      api.reload('7200e305', component.options)
    }
    module.hot.accept("./RouteItem.vue?vue&type=template&id=7200e305&scoped=true&", function () {
      api.rerender('7200e305', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/App/BucketNavBar/RouteItem.vue"
export default component.exports